import { appDomains, developmentDomains, tenantDomains } from '../config/domains.js';
import { isProductEnabled } from '../config/products.js';

/** Detect the product without inferring sessions or access. */
export function detectProductId(hostname = globalThis.location?.hostname ?? '') {
  if (typeof hostname !== 'string') return null;
  const host = hostname.trim().toLowerCase().replace(/\.$/, '');

  if (Object.prototype.hasOwnProperty.call(appDomains, host)) {
    return isProductEnabled(appDomains[host]) ? appDomains[host] : null;
  }
  if (import.meta.env?.DEV && Object.prototype.hasOwnProperty.call(developmentDomains, host)) {
    return developmentDomains[host];
  }

  for (const { domain, productId, excludedSubdomains } of tenantDomains) {
    if (!host.endsWith(`.${domain}`)) continue;
    const tenant = host.slice(0, -(domain.length + 1));
    // Allow a single tenant label within a strict domain boundary.
    if (/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(tenant)
      && !excludedSubdomains.includes(tenant) && isProductEnabled(productId)) return productId;
  }

  return null;
}
